import { useEffect, useState } from "react";
import { doneStore } from "./store";

export function useDone() {
  const [, force] = useState(0);

  useEffect(() => {
    const unsubscribe = doneStore.subscribe(() => force((x) => x + 1));
    return () => {
      unsubscribe();
    };
  }, []);

  return {
    isDone: (uid: string) => doneStore.isDone(uid),
    markDone: (uid: string) => doneStore.markDone(uid),
    unDone: (uid: string) => doneStore.unDone(uid),
  };
}
